/**
 * <s-withdrawal-form> — two-step confirmation for the withdrawal form.
 * Step 1: the native submit validates the fields, then opens the confirmation dialog instead of sending.
 * Step 2: only the submit buttons inside the dialog actually send the form.
 * Without JavaScript the form submits directly.
 *
 * Markup: a <form> containing a <dialog data-confirm>, [data-summary-order], [data-summary-email]
 * and a [data-keep] notice shown when the customer chooses to keep testing.
 */
class SWithdrawalForm extends HTMLElement {
  #ac;

  connectedCallback() {
    const form = this.querySelector('form');
    const dialog = this.querySelector('dialog[data-confirm]');
    if (!form || !dialog) return;

    this.#ac = new AbortController();
    const { signal } = this.#ac;

    form.addEventListener(
      'submit',
      (event) => {
        if (event.submitter && dialog.contains(event.submitter)) return;
        event.preventDefault();
        this.#fillSummary(form);
        this.querySelector('[data-keep]')?.setAttribute('hidden', '');
        dialog.showModal();
      },
      { signal }
    );

    this.querySelector('[data-keep-testing]')?.addEventListener(
      'click',
      () => {
        dialog.close();
        const notice = this.querySelector('[data-keep]');
        if (!notice) return;
        notice.removeAttribute('hidden');
        notice.focus();
      },
      { signal }
    );

    dialog.addEventListener(
      'click',
      (event) => {
        if (event.target === dialog) dialog.close();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #fillSummary(form) {
    const order = form.querySelector('[name="contact[Bestellnummer]"]')?.value ?? '';
    const email = form.querySelector('[name="contact[email]"]')?.value ?? '';
    const orderTarget = this.querySelector('[data-summary-order]');
    const emailTarget = this.querySelector('[data-summary-email]');
    if (orderTarget) orderTarget.textContent = order;
    if (emailTarget) emailTarget.textContent = email;
  }
}

if (!customElements.get('s-withdrawal-form')) customElements.define('s-withdrawal-form', SWithdrawalForm);
